/**
 * letter-nav.js
 * Liens #letter-X de la nav alphabétique (Default/_letter_nav.html.twig) :
 * un simple scroll animé vers la section, sans passer par le routeur ajax
 * (même page, pas de fetch). Délégué sur document.body : fonctionne même
 * après un remplacement de #main par le routeur, sans réinit nécessaire.
 */

import {on} from 'embo/utils/events'
import animate from 'embo/utils/animate'

const SELECTOR = 'a[href^="#letter-"]'

function headerHeight() {
  const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height')
  return parseFloat(value) || 0
}

export function initLetterNav() {
  on(document.body, 'click', SELECTOR, ({event, target}) => {
    const el = document.getElementById(target.getAttribute('href').slice(1))
    if (!el) return

    event.preventDefault()

    // compense #main-header en position: fixed, comme le scroll-margin-top
    // du h2 pour une navigation directe (cf. overrides/_archives.scss)
    const offset = el.getBoundingClientRect().top + window.scrollY - headerHeight()

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, offset)
      return
    }

    animate(document.documentElement, 'scroll', {offset, duration: 300})
  })
}
